"use strict";

var _toArray = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toArray");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * A tree structure that holds all contexts,
 * based on their position in the JSON object.
 *
 * Positions are identified by a path of keys.
 */

var ContextTree =
/*#__PURE__*/
function () {
  function ContextTree() {
    _classCallCheck(this, ContextTree);

    this.subTrees = {};
  }

  _createClass(ContextTree, [{
    key: "getContext",
    value: function getContext(_ref) {
      var _ref2 = _toArray(_ref),
          head = _ref2[0],
          tail = _ref2.slice(1);

      if (!head && !tail.length) {
        return this.context;
      } else {
        var subTree = this.subTrees[head];
        return subTree && subTree.getContext(tail) || this.context;
      }
    }
  }, {
    key: "setContext",
    value: function setContext(_ref3, context) {
      var _ref4 = _toArray(_ref3),
          head = _ref4[0],
          tail = _ref4.slice(1);

      if (!head && !tail.length) {
        this.context = context;
      } else {
        var subTree = this.subTrees[head];

        if (!subTree) {
          subTree = this.subTrees[head] = new ContextTree();
        }

        subTree.setContext(tail, context);
      }
    }
  }]);

  return ContextTree;
}();

exports.ContextTree = ContextTree;